import { Platform } from 'react-native'
import { isAccountAdminWebDrawerHostPath } from './accountAdminWebDrawerHostPath.helper'

export { isAccountAdminWebDrawerHostPath } from './accountAdminWebDrawerHostPath.helper'

/**
 * Web routes where a single root-mounted org drawer stays alive across navigations
 * (avoids RN Web Modal teardown calling `onRequestClose` and clearing drawer state).
 */
export function isAccountAdminWebDrawerHostRoute(pathname: string): boolean {
  return Platform.OS === 'web' && isAccountAdminWebDrawerHostPath(pathname)
}
